import request from '@/utils/request'


// 查询挑战赛列表
export function listChallenge(query) {
  return request({
    url: '/challenge/challenge/list',
    method: 'get',
    params: query
  })
}

// 查询挑战赛分页
export function pageChallenge(query) {
  return request({
    url: '/challenge/challenge/page',
    method: 'get',
    params: query
  })
}

// 查询挑战赛详细
export function getChallenge(data) {
  return request({
    url: '/challenge/challenge/detail',
    method: 'get',
    params: data
  })
}

// 新增挑战赛
export function addChallenge(data) {
  return request({
    url: '/challenge/challenge/add',
    method: 'post',
    data: data
  })
}

// 修改挑战赛
export function updateChallenge(data) {
  return request({
    url: '/challenge/challenge/edit',
    method: 'post',
    data: data
  })
}

// 查看排名
export function viewRanking(query) {
  return request({
    url: '/challenge/challenge/viewRanking',
    method: 'get',
    params: query
  })
}

// 删除挑战赛
export function delChallenge(data) {
  return request({
    url: '/challenge/challenge/delete',
    method: 'post',
    data: data
  })
}
